<template>
    <div class="protocal-box">
        <MenuList 
            :son_id="state.son_id" 
            :fater_id="state.fater_id"
            @getDetail="getDetail" />
        <div class="protocal-content">
            <strong class="protocal-content-title">{{ state.title }}</strong>
            <div ref="editorBox"></div>
            <div class="feedback_box">
                <el-radio v-model="state.feedbackType" :label="1" class="feedback_label">
                    建议与反馈
                </el-radio>
                <div v-if="state.feedbackType === 1" class="feedback_input_wrap">
                    <el-input
                        v-model="state.feedbackText"
                        type="textarea"
                        class="feedback_textarea"
                        maxlength="200"
                        :rows="4"
                        resize="none"
                        placeholder="请输入您的建议与反馈"
                    />
                    <div class="feedback_count">{{ getFeedbackLength() }}/200</div>
                </div>
                <el-button
                    v-if="state.feedbackType === 1"
                    type="primary"
                    class="feedback_submit"
                    :loading="state.submitLoading"
                    :disabled="getFeedbackLength() < 1"
                    @click="handleSubmitFeedback"
                >
                    提交
                </el-button>
            </div>
        </div>
    </div>
</template>

<script setup>
import MenuList from "@@/protocal/menu.vue"

import { getRulePublicityDetail, postHelpcenterQuestionDetails } from "@/api/index"
import { reactive, onMounted, ref } from "vue"
import { useRoute } from "vue-router";
import cont_match_reg from 'md-base-tools/editor'
import { decodeEntities } from "@/utils/tools.js"
import { ElMessage } from "element-plus";

const state = reactive({
    id: '',
    title: '',
    info: {},
    content: '',
    feedbackType: 0,
    feedbackText: "",
    submitLoading: false
})

const editorBox = ref({});
const route = useRoute();
onMounted(() => {
    state.id = route.params.rule_id

    getDetail()
})

const getDetail = () => {
    getRulePublicityDetail({
        id: state.id
    }).then(async res => {
        if (res.status == 0) {
            state.info = res.data
            state.title = res.data?.title || ''
            document.title = state.title

            let cont = state.info?.content || ''
            if (typeof cont === "string" && cont.indexOf('&gt;') > -1){
                cont = decodeEntities(cont)
            }

            editorBox.value.innerHTML = ""

            const html = await cont_match_reg(cont, process.env.VUE_APP_ENV, 800, 'project')
            editorBox.value.appendChild(html)
        }
    })
}

const handleSubmitFeedback = async () => {
    if (getFeedbackLength() < 1) return
    if (state.submitLoading) return

    state.submitLoading = true
    try {
        const res = await postHelpcenterQuestionDetails({
            lid: state.id,
            cid: 99,
            content: (state.feedbackText || "").trim(),
            enviroment: window.navigator.userAgent
        })

        if (Number(res?.status) === 2000) {
            state.feedbackText = ""
            ElMessage({
                type: "success",
                message: "留言已收到，1-3个工作日内给您答复"
            })
            return
        }

        ElMessage({
            type: "warning",
            message: res?.message || "提交失败，请稍后重试"
        })
    } catch (error) {
        ElMessage({
            type: "error",
            message: "提交失败，请稍后重试"
        })
    } finally {
        state.submitLoading = false
    }
}

const getFeedbackLength = () => {
    return (state.feedbackText || "").trim().length
}

</script>

<style lang="scss" scoped>
.protocal-box {
    width: 1080px;
    margin: 40px auto;
    display: flex;
    .protocal-content {
        width: 0;
        flex: 1;
        line-height: 24px;
        font-size: 16px;
        &-title {
            display: block;
            font-size: 24px;
            line-height: 40px;
            padding-bottom: 10px;
            border-bottom: 1px solid #E8E8E8;
            margin-bottom: 36px;
        }
        .feedback_box {
            margin-top: 40px;
            .feedback_label {
                display: inline-flex;
                align-items: center;
                color: #333333;
                font-size: 20px;
                line-height: 28px;
                cursor: pointer;
            }
            .feedback_input_wrap {
                margin-top: 16px;
                border: 1px solid #d9d9d9;
                padding: 16px;
                .feedback_textarea {
                    :deep(.el-textarea__inner) {
                        min-height: 120px !important;
                        border: none;
                        box-shadow: none;
                        padding: 0;
                        font-size: 18px;
                        line-height: 26px;
                        color: #333333;
                    }
                }
                .feedback_count {
                    text-align: right;
                    color: #999999;
                    font-size: 16px;
                    line-height: 24px;
                    margin-top: 8px;
                }
            }
            .feedback_submit {
                display: block;
                margin-left: auto;
                margin-top: 16px;
                width: 120px;
                height: 44px;
                font-size: 18px;
            }
        }
    }
    // .protocal-content-content {
    //     .p-padding span {
    //         font-family: PingFang SC-Regular, PingFang SC;
    //         font-size: 16px !important;
    //     }
    // }

}
</style>
